<template>
  <div>
    <div class="position-relative">
      <ContainerBox
        style="padding: 20px"
        v-if="current_form !== UserInfoFormEnum.NewPassword"
      >
        <div>
          <CheckForm
            v-if="current_form === UserInfoFormEnum.Check"
            :email="email"
            @emailChange="(email: string) => handleEmailChange(email)"
            @emailExists="isEmailExists => handleEmailExists(isEmailExists)"
          />
          <LoginForm
            v-if="current_form === UserInfoFormEnum.Login"
            :email="email"
            :isDisplayEmailSentMessage="isDisplayEmailSentMessage"
            :emailSentTo="emailSentTo"
            @emailChange="email => handleEmailChange(email)"
            @resetPassword="
              () => handleShowDifferentForm(UserInfoFormEnum.Reset)
            "
            @useOtherEmail="
              () => handleShowDifferentForm(UserInfoFormEnum.Check)
            "
          />
          <ResetForm
            v-if="current_form === UserInfoFormEnum.Reset"
            :email="email"
            @emailChange="(email: string) => handleEmailChange(email)"
            @emailSent="() => handleEmailSent()"
            @useOtherEmail="
              () => handleShowDifferentForm(UserInfoFormEnum.Check)
            "
          />
          <RegisterForm
            v-if="current_form === UserInfoFormEnum.Register"
            :email="email"
            @emailChange="email => handleEmailChange(email)"
            @useOtherEmail="
              () => handleShowDifferentForm(UserInfoFormEnum.Check)
            "
          />
        </div>
        <Overlay v-if="loadingSet.size" :additionalClasses="'loader'" />

        <div class="my-3" v-if="showNotEmailExistsError">
          <Banner :background="'var(--orange-100)'">
            <template #text>
              <span class="caption text-primary-orange">{{
                t('loginRegister.contacts_incorrect_credentials')
              }}</span>
            </template>
          </Banner>
        </div>
      </ContainerBox>
      <NewPasswordForm v-else />
    </div>
    <Overlay
      style="padding: 20px"
      v-if="showResetPopUp"
      :isTransitioning="true"
      :position="'fixed'"
      :background="'rgba(13, 20, 27, 0.9)'"
      :zIndex="9999"
    >
      <ResetPopUp />
    </Overlay>
  </div>
</template>

<script lang="ts" setup>
  import { onUnmounted, ref, computed } from 'vue'
  import UserInfoFormEnum from '@/config/UserInfoFormEnum'

  // common components
  import ContainerBox from '@/components/LoginRegister/common/ContainerBox/v1/ContainerBox.vue'
  import Overlay from '@/components/LoginRegister/common/Overlay/v1/Overlay.vue'
  import Banner from '@/components/LoginRegister/common/Banner/v1/Banner.vue'

  // form components
  import CheckForm from '@/components/LoginRegister/CheckForm.vue'
  import LoginForm from '@/components/LoginRegister/LoginForm.vue'
  import ResetForm from '@/components/LoginRegister/ResetForm.vue'
  import RegisterForm from '@/components/LoginRegister/RegisterForm.vue'
  import NewPasswordForm from '@/components/LoginRegister/NewPasswordForm.vue'
  import ResetPopUp from '@/components/LoginRegister/ResetPopUp.vue'

  // state
  import current_form from '@/state/current_form'
  import email from '@/state/email'
  import loadingSet from '@/state/loadingSet'
  import showResetPopUp from '@/state/showResetPopUp'
  import emailSentTo from '@/state/emailSentTo'
  import isDisplayEmailSentMessage from '@/state/isDisplayEmailSentMessage'

  // Logic
  import handleEmailSent from '@/logic/contact/handleEmailSent'

  // Translations
  import { useI18n } from 'vue-i18n'
  const { t } = useI18n()

  // Use locale directly from the env to avoid translated locale(ski school etc)
  const locale = window.env.VUE_APP_LOCALE

  // refs
  const emailExists = ref<boolean>(true)

  const handleEmailChange = (newVal: string) => {
    email.value = newVal
  }
  const handleEmailExists = (isEmailExists: boolean) => {
    emailExists.value = isEmailExists
    if (emailExists.value) {
      current_form.value = UserInfoFormEnum.Login
    } else if (!emailExists.value && locale !== 'fr-FR-CSE') {
      // Only show the registration for non cse account
      current_form.value = UserInfoFormEnum.Register
    }

    isDisplayEmailSentMessage.value = false
    emailSentTo.value = ''
  }
  const handleShowDifferentForm = (newVal: UserInfoFormEnum) => {
    current_form.value = newVal
  }

  // Computed

  // Only show the error in case of cse, for other locales we show the register form
  const showNotEmailExistsError = computed<boolean>(() => {
    return !emailExists.value && locale === 'fr-FR-CSE'
  })

  onUnmounted(() => {
    handleShowDifferentForm(UserInfoFormEnum.Check)
  })
</script>

<style scoped>
  .login-register-wrapper-box {
    min-height: 80vh;
  }
</style>
